import QuestionLibrary from "pages/QuestionPage/QuestionLibrary/QuestionLibrary";

export default QuestionLibrary;
